import { getNodeByFlag } from "../../common/controlBar/controlBarDialog/metaComponent/utils"
import { washProductListItem } from '@/utils/wash.js'

export function washData_listNews(walkedNode){
  if(walkedNode._type === 'list_news1'){
    if(
        walkedNode.list &&
        walkedNode.list[1] &&
        walkedNode.list[1].list &&
        walkedNode.list[1].list[4] &&
        walkedNode.list[1].list[4].componentName === 'button_text'
    ){
      var buttonNode = walkedNode.list[1].list[4]
      buttonNode.actions = [
        {
          "name": "design",
          "groupLayout": "topBottom",
          "config": {
            "文字设计": [
              "self_fontFamily",
              "self_textTheme",
              "self_fontSize",
              "self_color",
              "self_textStyle",
              "self_textAlign",
              "self_textInput"
            ],
            "按钮设计": [
              "self_width",
              "self_background",
              "self_border",
              "self_margin",
              "self_padding",
              "self_transverseMargin",
              "self_borderRadius",
              "self_shadow"
            ]
          }
        },
        "hover",
        "translate"
      ]
      buttonNode.flag = 'listItem_button'
    }
  }
  else if(walkedNode._type === 'list_news2'){

    if(
      walkedNode.list &&
      walkedNode.list[0] &&
      walkedNode.list[0].list &&
      walkedNode.list[0].list[1] &&
      walkedNode.list[0].list[1].list &&
      walkedNode.list[0].list[1].list[0].list &&
      walkedNode.list[0].list[1].list[0].list[0] &&
      walkedNode.list[0].list[1].list[0].list[0].list &&
      walkedNode.list[0].list[1].list[0].list[0].list[0] &&
      walkedNode.list[0].list[1].list[0].list[0].list[0].componentName === 'button_text_icon'
    ){
      var buttonNode = walkedNode.list[0].list[1].list[0].list[0].list[0]
      buttonNode.flag='listItem_button'
      buttonNode.actions = [
        'design',
        'hover',
        "translate"
      ]
    }
  }
  else if(walkedNode._type === 'list_news3'){

    if(
      walkedNode.list &&
      walkedNode.list[0] &&
      walkedNode.list[0].list &&
      walkedNode.list[0].list[1] &&
      walkedNode.list[0].list[1].list &&
      walkedNode.list[0].list[1].list[3].list &&
      walkedNode.list[0].list[1].list[3].list[0] &&
      walkedNode.list[0].list[1].list[3].list[0].componentName === 'button_text_icon'
    ){
      var buttonNode = walkedNode.list[0].list[1].list[3].list[0]
      buttonNode.actions = [
        {
          "name": "design",
          "groupLayout": "topBottom",
          "config": {
            "文字设计": [
              "self_fontFamily",
              "self_textTheme",
              "self_fontSize",
              "self_color",
              "self_textStyle",
              "self_textAlign",
              "self_textInput"
            ],
            "按钮设计": [
              "self_width",
              "self_background",
              "self_border",
              "self_margin",
              "self_padding",
              "self_transverseMargin",
              "self_borderRadius",
              "self_shadow"
            ]
          }
        },
        "hover",
        "translate"
      ]
    }
  }
  else if(walkedNode._type === 'list_news4'){
    if(
        walkedNode.list &&
        walkedNode.list[0] &&
        walkedNode.list[0].list &&
        walkedNode.list[0].list[4] &&
        walkedNode.list[0].list[4].componentName === 'button_text'
    ){
      var buttonNode = walkedNode.list[0].list[4]
      buttonNode.flag='listItem_button'
      buttonNode.actions = [
        {
          name: 'design',
          groupLayout: 'topBottom',
          config: {
            文字设计: [
              'self_textInput',
              'self_fontFamily',
              'self_textTheme',
              'self_fontSize',
              'self_color',
              'self_textStyle',
              'self_textAlign'
            ],
            按钮设计: [
              'self_background',
              'self_border',
              'self_margin',
              'self_padding',
              'self_transverseMargin',
              'self_borderRadius',
              'self_shadow'
            ]
          }
        },
        'hover',
        'translate'
      ]
    }
    washProductListItem(walkedNode, 'item')
    getNodeByFlag(walkedNode,'abstract').forceShowEye = true
    getNodeByFlag(walkedNode,'listItem_button').forceShowEye = true
  }
  else if(walkedNode._type === 'list_news5'){
    if(
        walkedNode.list &&
        walkedNode.list[0] &&
        walkedNode.list[0].list &&
        walkedNode.list[0].list[4] &&
        walkedNode.list[0].list[4].list &&
        walkedNode.list[0].list[4].list[0] &&
        walkedNode.list[0].list[4].list[0].list &&
        walkedNode.list[0].list[4].list[0].list[0]&&
        walkedNode.list[0].list[4].list[0].list[0].componentName=='button_icon'
    ){
      var buttonNode = walkedNode.list[0].list[4].list[0].list[0]
      buttonNode.flag='listItem_button'
      console.log(buttonNode,'buttonNode');

    }
  }
  else if(walkedNode._type === 'list_news6'){
    var buttonNode = getNodeByFlag(walkedNode,'item').list[1].list[0]
    buttonNode.flag='listItem_button'
  }
}
